<template>
    <v-container fluid>
        <v-row class="pt-2" justify="center" align="center">
            <v-col>
                <h1 class="text-center">Research</h1>
            </v-col>
        </v-row>
        <v-card
            class="mx-auto justify-center pt-2 pb-2"
            flat
        >
            <v-row justify="center" align="center">
                <v-col
                    cols="12"
                    md="6"
                >
                    <v-card-title class="justify-center" v-text=item.headline0></v-card-title>
                    <v-card-subtitle class="text-center" v-text=item.one_line_intro></v-card-subtitle>
                    <v-card-text class="text-center">
                        <div v-text=item.research_statement></div>
                    </v-card-text>
                </v-col>  
            </v-row>
        </v-card>
        <v-card
            class="mx-auto justify-center pt-2"
            flat
        >
            <v-row justify="center" align="center">
                <v-col
                    cols="12"
                    md="6"
                >
                    <v-card-title class="justify-center" v-text=item.headline1></v-card-title>
                    <v-card-subtitle class="text-center" v-text=item.institution></v-card-subtitle>
                    <v-card-text class="text-center">
                        <p>
                            <a href="https://arxiv.org/abs/2004.09704" v-text=item.paper0></a>
                        </p>
                    </v-card-text>
                </v-col>  
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "Research",
    data: () => ({
        item: {
            headline0: "Research Interests",
            one_line_intro: "Fields: Classical and Harmonic Analysis, PDEs, and Low Dimensional Topology",
            research_statement: "My goal, roughly, is to explore mathematics that describe various aspects \
            of the world around us: many naturally occurring phenomena are quite excellently modelled by PDEs. \
            Moreover, we as humans find ourselves inside a curved 3-manifold, supplemented with a temporal dimension. \
            Therefore, the two fields that most aptly investigate properties pertinent to human understanding of the \
            universe are Low Dimensional Topology and PDEs.",
            headline1: "Submitted Paper",
            institution: "with Paata Ivanisvili, UC Irvine, 2019",
            paper0: "Exponential Integrability for Log-Concave Measures"
        }
    })
}
</script>

<style lang="css" scoped>
.v-card {
    padding-top: 2%;
}
</style>